import React from 'react';

// Multibrand-UI Components
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import StringConstants from 'app/shared/constants/StringConstants';

// styles
import './style.scss';

const FraudFailureModal = ({ brand }) => {
    const isZillow = brand === StringConstants.UNFORMATTED_BRAND_NAMES.zillow;

    const email = isZillow ?
        'account_verification@zillow.com' :
        'account_verification@hotpads.com';

    const header = 'We can not publish your listing at this time.';
    const body = (
        <React.Fragment>
            <div>
                Please contact&nbsp;
                <Link href={`mailto:${email}`} escape={true}>{email}</Link>
                &nbsp;to resolve the issue.
            </div>
        </React.Fragment>
    );

    return (
        <div className="FraudFailureModal">
            <Text className="FraudFailureModal-Header" type="h3">{header}</Text>
            <Text className="FraudFailureModal-Body" type="body">{body}</Text>
        </div>
    );
};

export default FraudFailureModal;
